import ZkResourceTree from './src/main'
ZkResourceTree.install = function (Vue) {
  Vue.component(ZkResourceTree.name, ZkResourceTree)
}
export default ZkResourceTree



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/resourceTree/index.js